import { h, createContext, ComponentChildren } from 'preact';
import { useContext, useEffect, useState, useCallback } from 'preact/hooks';
import { checkAuthentication } from '../services/api';
import type { UserKeyCheckResponse } from '../types';
// @ts-ignore - constants.js is vanilla JS
import { STORAGE_KEYS, storageSet, storageRemove } from '../../constants.js';

interface AuthContextValue {
  user: UserKeyCheckResponse | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: true,
  refresh: async () => {},
});

export function AuthProvider({ children }: { children: ComponentChildren }) {
  const [user, setUser] = useState<UserKeyCheckResponse | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const result = await checkAuthentication();
    setUser(result);
    if (result) {
      if (result.userAlias !== null) {
        await storageSet(STORAGE_KEYS.USER_ALIAS, result.userAlias);
      } else {
        await storageRemove(STORAGE_KEYS.USER_ALIAS);
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AuthContext.Provider value={{ user, loading, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
